export default "assets/images/logo-footer-c1423744.png";